import React, { useEffect } from "react";
import { ConfigProvider, Layout, Spin } from "antd";
import CustomHeader from "../src/layouts/AppHeader.tsx";
import AppRoutes from "./routes/AppRoutes.tsx";
import { getCurrentUser, fetchAuthSession } from "aws-amplify/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setUserData,
  setUserLoggedIn,
  setUserLoggedOut,
} from "./redux/authSlice.ts";
import { setUserDetails, clearUserDetails } from "./redux/userSlice.ts";
import RoutePersist from "./routes/route-persist.ts";
import { RootState } from "../src/redux/store.ts";
import NotificationProvider from "./shared/components/notificationProvider.tsx";
import userService from "./services/user-service.ts";
import Constant from "./global/Constant.ts";
import CookieConsent from "./components/CookieConsent/CookieConsent.tsx";
import { decryptData } from "./utils/decryptData.ts"; // adjust path if needed
import WelcomePopup from "./components/WelcomePopup/WelcomePopup.tsx";
const { Content } = Layout;

const App = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.global.loading);

  const fetchUserDetailsByEmail = async (email: string) => {
    try {
      // Replace this with your actual API call to fetch user details by email
      const responseEncrypted = await userService.getUserDetailsByEmail(
        Constant.userdetails
      );
      const response = await decryptData(
        responseEncrypted?.data,
        process.env.REACT_APP_ENCRYPTION_KEY!
      );
      dispatch(setUserDetails(response));
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      dispatch(clearUserDetails());
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const user = await getCurrentUser();
        const session = await fetchAuthSession();
        let userAttributes = {};

        if (session && session.tokens) {
          const idToken = session.tokens.idToken;
          const payload = idToken.payload;
          userAttributes = {
            ...user,
            groups: payload["cognito:groups"] || [],
          };

          // Fetch user details by email
          const email = userAttributes.signInDetails?.loginId;
          if (email) {
            await fetchUserDetailsByEmail(email);
          }
        }

        dispatch(setUserData(userAttributes));
        dispatch(setUserLoggedIn());
      } catch (error) {
        dispatch(setUserLoggedOut());
        dispatch(clearUserDetails());
      }
    };

    checkUserSession();
  }, [dispatch]);

  return (
    <ConfigProvider>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout>
          <CustomHeader />
          <Content style={{ padding: "0 22px" }}>
            <div className="vm__py-4 vm__h-100 vm__set-overflow-auto">
              <RoutePersist />
              <NotificationProvider />

              <Spin
                className="vm__h-100 vm__max-h-100 "
                spinning={loading}
                size="large"
              >
                <AppRoutes />
                {/* <WelcomePopup /> */}
                <CookieConsent />
              </Spin>
            </div>
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default App;
